import { BaseInput, BaseInputGroup } from "@/components/input/CustomInputs";
import { formInterface } from "@/interface/dataInterface";
import { Eye, EyeOff } from "lucide-react";
import { FC, useState } from "react";

const PartnersForm: FC<formInterface> = ({ mode, formProp, setFormProp }) => {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <div className="grid sm:grid-cols-2 gap-4">
      <BaseInput
        id="firstname"
        label="First name"
        value={formProp.firstname}
        setProp={setFormProp}
        placeholder="Partner first name"
      />
      <BaseInput
        id="lastname"
        label="Last name"
        value={formProp.lastname}
        setProp={setFormProp}
        placeholder="Partner last name"
      />
      <div className={`${mode === "edit" && "sm:col-span-2"} w-full`}>
        <BaseInput
          id="email"
          label="Email"
          value={formProp.email}
          setProp={setFormProp}
          placeholder="partner@email.com"
          type="email"
        />
      </div>
      {mode === "create" && (
        <BaseInputGroup
          id="password"
          label="Password"
          value={formProp.password}
          setProp={setFormProp}
          placeholder="*******"
          type={showPassword ? "text" : "password"}
        >
          <div className="h-full py-2">
            <span
              onClick={() => setShowPassword((prev) => !prev)}
              className=" flex items-start justify-end pr-3 cursor-pointer"
            >
              {showPassword ? <Eye size={20} /> : <EyeOff size={20} />}
            </span>
          </div>
        </BaseInputGroup>
      )}
      <BaseInput
        id="phone"
        label="Phone number"
        value={formProp.phone}
        setProp={setFormProp}
        placeholder="Enter phone number"
        type="number"
      />
      <BaseInput
        id="percentage_commission"
        label="Commission (%)"
        type="number"
        value={formProp.percentage_commission}
        setProp={setFormProp}
        max={100}
      />
    </div>
  );
};

export default PartnersForm;
